import { formatDate, parseDate } from "devextreme/localization";


export function formatShortDate(date: Date | undefined) {
	return !!date ? formatDate(date, 'shortDate') : '';
}

export function formatIsoDate(date: Date | undefined) {
	return !!date ? formatDate(date, 'yyyy-MM-dd') : '';
}

export function formatShortDateShortTime(date: Date | undefined) {
	if (!!date) {
		return formatDate(date, 'shortTime') === '12:00 AM' ?
			formatDate(date, 'shortDate') :
			formatDate(date, 'shortDateShortTime').replace(',', '');
	}

	return '';
}

export function formatShortTime(date: Date | undefined) {
	let result = !!date ? formatDate(date, 'shortTime') : '';
	return result !== '12:00 AM' ? result : undefined;
}

export function formatLongDate(date: Date | undefined, noWeekDay?: boolean) {
	return !!date ?
		(noWeekDay ? formatDate(date, 'MMMM d, y') : formatDate(date, 'longDate')) : '';
}

export function setTimeForDate(date: Date, time: string) {
	if (!!time)
		return parseDate(formatDate(date, 'shortDate') + ', ' + time, 'shortDateShortTime');
	else
		return parseDate(formatDate(date, 'shortDate'), 'shortDate')
}

export enum TimeframeType {
	Short = 1,
	Long = 2
}

export function formatDateWithTimeframe(date: Date | undefined, timeframeType: TimeframeType) {
	if (!date)
		return '';

	let timeframe = getTimeframeByDate(date, timeframeType);
	return formatDate(date, 'shortDate') + (!!timeframe ? ' ' + timeframe.description : '');
}

export interface TimeFrame {
	start: number,
	end: number,
	description: string
}

const _longTimeFrames: TimeFrame[] = [
	{ start: 8, end: 12, description: '8AM - Noon' },
	{ start: 12, end: 16, description: 'Noon - 4PM' },
	{ start: 16, end: 18, description: '4PM - 6PM' },
	{ start: 18, end: 20, description: '6PM - 8PM' }
];

const _shortTimeFrames: TimeFrame[] = [
	{ start: 8, end: 10, description: '8AM - 10AM' },
	{ start: 10, end: 12, description: '10AM - Noon' },
	{ start: 12, end: 14, description: 'Noon - 2PM' },
	{ start: 14, end: 16, description: '2PM - 4PM' },
	{ start: 16, end: 18, description: '4PM - 6PM' },
	{ start: 18, end: 20, description: '6PM - 8PM' }
];

export function getTimeFrames(timeframeType: TimeframeType) {
	return timeframeType === TimeframeType.Long ? _longTimeFrames : _shortTimeFrames;
}

export function getTimeframeByDescription(description: string | undefined, timeframeType: TimeframeType) {
	var timeFrames = timeframeType === TimeframeType.Long ? _longTimeFrames : _shortTimeFrames;
	return timeFrames.find((x) => x.description === description);
}

export function getTimeframeByDate(date: Date | undefined, timeframeType: TimeframeType) {
	var timeFrames = timeframeType === TimeframeType.Long ? _longTimeFrames : _shortTimeFrames;
	return timeFrames.find((x) => x.start === date?.getHours());
}

export function getCurrentDate() {
	var date = new Date()
	date.setHours(0, 0, 0, 0);
	return date;
}


export function disablePastDates(valueToCheck: Date, currentValue?: Date) {

	const valueToCheckISODate = valueToCheck.toISOString().split('T')[0];

	if (currentValue && valueToCheckISODate === currentValue.toISOString().split('T')[0])
		return false;

	return valueToCheckISODate < new Date(new Date().toLocaleDateString()).toISOString().split('T')[0];
}

export function getCurrentQuarterDates() {
	const today = new Date();
	const quarter = Math.floor(today.getMonth() / 3) + 1;
	const startQuarter = new Date(today.getFullYear(), (quarter - 1) * 3, 1);
	const endQuarter = new Date(startQuarter.getFullYear(), startQuarter.getMonth() + 3, 0);

	return {
		startDate: startQuarter,
		endDate: endQuarter
	};
}